import React from "react";
import { Route, Redirect, RouteProps } from "react-router-dom";

import { useTypedSelector } from "hooks";

interface PrivateRouteProps extends RouteProps {
  component: React.ComponentType<any>;
}

const PrivateRoute = ({
  component: Component,
  ...rest
}: PrivateRouteProps): JSX.Element => {
  const { isAuthorized } = useTypedSelector((state) => state.auth);

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthorized ? <Component {...props} /> : <Redirect to="/login" />
      }
    />
  );
};

export default PrivateRoute;
